"use client";

import { SQ_SID_COOKIE_NAME } from "@repo/identity";

const ONE_YEAR_SECONDS = 60 * 60 * 24 * 365;

export function readSqSidCookie(): string | null {
	if (typeof document === "undefined") {
		return null;
	}
	const match = document.cookie.match(
		new RegExp(`(?:^|; )${SQ_SID_COOKIE_NAME}=([^;]*)`),
	);
	const value = match?.[1];
	return value ? decodeURIComponent(value) : null;
}

export function writeSqSidCookie(sqid: string): void {
	if (typeof document === "undefined") {
		return;
	}
	const encoded = encodeURIComponent(sqid.trim());
	// biome-ignore lint/suspicious/noDocumentCookie: the Cookie Store API it recommends is async and not in every browser we support; this is a synchronous first-party write
	document.cookie = `${SQ_SID_COOKIE_NAME}=${encoded}; Max-Age=${ONE_YEAR_SECONDS}; Path=/; SameSite=Lax`;
}

export function readSqidHandoffFromUrl(): string | null {
	if (typeof window === "undefined") {
		return null;
	}
	const sqid = new URLSearchParams(window.location.search).get("sqid");
	return sqid?.trim() || null;
}

export function readSessionAttributionFromLocation(): {
	utmSource?: string;
	utmMedium?: string;
	utmCampaign?: string;
	referrer?: string;
} {
	if (typeof window === "undefined") {
		return {};
	}
	const params = new URLSearchParams(window.location.search);
	return {
		utmSource: params.get("utm_source") ?? undefined,
		utmMedium: params.get("utm_medium") ?? undefined,
		utmCampaign: params.get("utm_campaign") ?? undefined,
		referrer: document.referrer || undefined,
	};
}
